import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import QuotationList from "./pages/QuotationList";
import ClientList from "./pages/ClientList";
import ServiceChecklist from "./components/ServiceCheckList";
import GunQuotation from "./components/quotations/gun/GunQuotation";
import LoginForm from "./components/quotations/loginForm";
import ReportingSheets from "./ReportingSheets"
import Credentials from "./Credentials"
import LeadToSheet from "./components/LeadToSheet"
import ComponentsIssues from "./components/ComponentsIssues"
import ServiceReportsList from "./pages/ServiceReportsList"
import AdditionalServices from "./pages/AdditionalServices"
import IMLeads from "./pages/IMLeads"
import Downloads from "./pages/Downloads"
import Testing from "./pages/Testing"
import Dashboard from "./pages/Dashboard"
import ClientSellingRecord from "./pages/ClientSellingRecord"
import EmailsToClipBoardForm from "./pages/email/EmailsToClipBoardForm";
import EmailsInstallation from "./pages/email/installation/EmailsInstallation";

const rConf =
    { 
        Home, 
        Contact,
        About,
        ServiceChecklist,
        GunQuotation,
        LoginForm,
        ReportingSheets,
        Credentials,
        LeadToSheet,
        ComponentsIssues,
        QuotationList,
        ClientList,
        ServiceReportsList,
        AdditionalServices,
        IMLeads,
        Downloads,
        Testing,
        Dashboard,
        ClientSellingRecord,
        EmailsToClipBoardForm,
        EmailsInstallation
    }


export default rConf;